import { Container, Grid } from "@mui/material";
import { FC, useEffect, useState } from "react";
import FormField from "../../../../components/common/FormField";
import CustomButton from "../../../../components/common/button/CustomButton";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateSurveyTabAction } from "../../../../store/reducers/leadSurveySlice";

const NotesTab: FC<any> = ({ disabledAction = false }) => {
  const [surveyNotes, setSurveyNotes]: any = useState(null);
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedItems } = useSelector((state: any) => state.leadSurvey);

  const dispatch = useDispatch();

  useEffect(() => {
    if (surveyedItems?.notes) {
      setSurveyNotes(surveyedItems?.notes);
    }
  }, [surveyedItems]);

  const onChangeAction = (event: any) => {
    const { id, value } = event.target;
    setSurveyNotes(value);
  };

  const submitHandler = () => {
    dispatch(
      updateSurveyTabAction({
        tab: "tab2",
        surveyId: leadDetails?.lead?.survey_id,
        data: {
          notes: surveyNotes,
        },
      })
    );
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Container fixed sx={{ bgcolor: "#fff", padding: "16px 0px" }}>
            <FormField
              {...{
                id: "surveyNotes",
                placeHolder: "",
                type: "textarea",
                minRows: 5,
                value: surveyNotes,
                editReadOnly: disabledAction,
                InputProps: {
                  sx: {
                    width: "100%",
                  },
                },
                onChange: (e: any) => onChangeAction(e),
              }}
            />
          </Container>
          {!disabledAction && (
            <div style={{ textAlign: "center" }}>
              <CustomButton title="Save" onClick={() => submitHandler()} />
            </div>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default NotesTab;
